import { ListItemButton, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function MaintenanceTaskElementSelectorElementItem({ item }) {
    const { selectedElement, setSelectedElement } = useBoundContext()
    const isSelected = selectedElement === item.key

    return (
        <ListItemButton dense selected={isSelected} onClick={handleClick} data-cy={`maintenance-element-${item.key}`}>
            <Stack direction="row" width={1} alignItems="center" justifyContent="space-between" spacing={1}>
                <Typography variant="body2" noWrap>
                    {item.label}
                </Typography>
                <Typography variant="caption" color="text.secondary" noWrap sx={{ flexShrink: 0 }}>
                    {item.valueType}
                </Typography>
            </Stack>
        </ListItemButton>
    )

    function handleClick() {
        setSelectedElement(item.key)
    }
}
